"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Getting langCountry with browser default props
var getLangCountry = function (getGoogleTranslation) {
    var lang = navigator.language.toLowerCase() ||
        navigator.userLanguage.toLowerCase();
    if (!getGoogleTranslation)
        return lang;
    return getGoogleTranslatedLanguageCookie(lang);
};
var getGoogleTranslatedLanguageCookie = function (browserLang) {
    var googleTranslatedLang = getCookie("googtrans");
    if (!googleTranslatedLang)
        return browserLang;
    var googleLang = googleTranslatedLang.substring(1).replace("/", "-");
    return "".concat(browserLang, "|lang:").concat(googleLang);
};
var getCookie = function (cname) {
    var match = document.cookie.match(new RegExp("(^| )" + cname + "=([^;]+)"));
    if (match)
        return match[2];
    return null;
};
exports.default = getLangCountry;
